import {
  containerCss,
  headerTextCss,
  headerInfoCss,
} from "./TableHeaderCell.style";

interface TableHeaderCellProps {
  shrinkHeader?: boolean;
  isClassroomPage?: boolean;
  headerTitle: string;
  headerInfo?: string;
}

const TableHeaderCell = ({
  shrinkHeader,
  headerTitle,
  headerInfo,
}: TableHeaderCellProps) => {
  return (
    <div css={containerCss}>
      <div css={headerTextCss(shrinkHeader)}>{headerTitle}</div>
      <div css={headerInfoCss}>{headerInfo}</div>
    </div>
  );
};

export default TableHeaderCell;
